import { Routes, Route } from 'react-router-dom'
import Layout from '@/layout'
import { ProtectedRoute } from '@/components/auth/protected-route'
import HomePage from '@/pages/home-page'
import PublishPage from '@/pages/publish-page'
import TrendingPage from '@/pages/trending-page'
import CategoryPage from '@/pages/category-page'
import ProfilePage from '@/pages/profile-page'
import UserProfilePage from '@/pages/user-profile-page'
import MessagePage from '@/pages/message-page'
import SearchPage from '@/pages/search-page'
import LoginPage from '@/pages/login-page'

import TermsPage from '@/pages/terms-page'
import PrivacyPage from '@/pages/privacy-page'
import { ErrorBoundary } from '@/components/ui/error-boundary'
import { ThemeProvider } from '@/components/theme-provider'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <ErrorBoundary>
        <ThemeProvider defaultTheme="light" storageKey="dawu-theme">
          <Routes>
            {/* 公开路由 */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            
            {/* 主要布局路由 - 游客可访问 */}
            <Route path="/" element={<Layout />}>
              {/* 游客可访问的页面 */}
              <Route index element={<HomePage />} />
              <Route path="trending" element={<TrendingPage />} />
              <Route path="category/:categoryName" element={<CategoryPage />} />
              <Route path="search" element={<SearchPage />} />
              <Route path="user/:userId" element={<UserProfilePage />} />
              
              {/* 需要登录的页面 */}
              <Route path="publish" element={
                <ProtectedRoute>
                  <PublishPage />
                </ProtectedRoute>
              } />
              <Route path="profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="messages" element={
                <ProtectedRoute>
                  <MessagePage />
                </ProtectedRoute>
              } />

            </Route>
          </Routes>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  )
}

export default App
